import { ColDef } from 'ag-grid-enterprise';

export interface ComposerActions {
  edit: boolean;
  delete: boolean;
  view: boolean;
}

export interface DataRow {
  key: string;
  label: string;
  sortlevel?: number;
  value: any;
  link?: boolean;
}

export interface RowItem {
  key: string;
  label: string;
  value: any;
  display_value: string;
  link?: boolean;
  rid?: string;
}

export interface FormSchemaItem {
  key: string;
  formtype: string;
  fieldtype: string;
  enum?: Array<{ name: string; value: any }>;
  options?: string;
  default_options?: string;
  default_option_key?: string[];
  section?: string;
  title?: string;
}

export interface ComposerTabData {
  name?: string;
  lines: RowItem[][];
  formSchema?: FormSchemaItem[];
  targetRid: string;
  layer?: string;
  actions: ComposerActions;
  _tabKey?: string;
  _paginationMeta?: { page: number; limit: number; total_count: number; has_more: boolean };
  _composerDataService?: any;
}

export interface ComposerRowData {
  row: RowItem[];
  actions: ComposerActions;
  formSchema: FormSchemaItem[];
  editedCell: string[];
  edited?: boolean;
  rid?: string;
  in?: string;
  out?: string;
  originalData?: ComposerRowData;
  [field: string]: any;
}

export const NUMERIC_FIELD_TYPES = new Set(['FLOAT', 'float', 'DOUBLE', 'number', 'NUMBER']);
export const NO_FILTER_TEXT_FIELDS = new Set(['type_label', 'Unit', 'unit']);
export const NO_EDIT_FIELDS = new Set(['is_private']);
export const YIELD_FACTOR_FIELD = 'yield_factor';
export const SUBSTITUTION_ALTERNATIVES_TAB = 'Substitution Alternatives';

export interface TabField {
  key: string;
  label: string;
  field_type: string;
  filter_type: 'text' | 'numeric' | 'date';
  filterable: boolean;
}

export interface ComposerTab {
  key: string;
  label: string;
  sort_order: number;
  fields: TabField[];
}

export interface ComposerNodeMeta {
  type: string;
  type_label: string;
  caption: string;
  rid: string;
}

export interface ComposerTabsResponse {
  operators: Record<string, string[]>;
  tabs: ComposerTab[];
  node_meta: ComposerNodeMeta;
}

export interface FilterCriteria {
  field: string;
  operation: string;
  value: any;
}

export interface OrderingCriteria {
  field: string;
  order: 'asc' | 'desc';
}

export interface PaginatedComposerResponse {
  items: any[];
  page: number;
  limit: number;
  total_count: number;
  has_more: boolean;
}

export const EDITABLE_BG = '#f5f7f8';
export const LINK_COLOR = '#4367de';

export const EDITABLE_CELL_STYLE: ColDef['cellStyle'] = { backgroundColor: EDITABLE_BG };
export const LINK_CELL_STYLE = (params: any, headerName: string): Record<string, string> => {
  const hasLink = params.data?.[`Link_${headerName}`] || params.data?.[`Link_${params.colDef.field}`];
  return hasLink
    ? { color: LINK_COLOR, backgroundColor: EDITABLE_BG, cursor: 'pointer' }
    : { backgroundColor: EDITABLE_BG };
};
